import { useQuery } from '@apollo/client';
import { get } from 'lodash';
import { useIntl, defineMessages } from 'react-intl';

import toast from 'helpers/toast';
import { GET_TASK_LIST_ASSIGNED_USERS } from 'components/projects/taskList/assign/graphql/queries.graphql.js';

const messages = defineMessages({
  error: {
    id: 'Project.taskList.assign.errorMessage',
    defaultMessage: 'There was a problem fetching the assigned users!',
    description:
      'toast error message when failure to fetch assigned tasklist users',
  },
});

const useTaskListAssignedUsers = ({ taskListId }) => {
  const intl = useIntl();
  const { data, loading, error } = useQuery(GET_TASK_LIST_ASSIGNED_USERS, {
    variables: { id: taskListId },
    onError: () => {
      toast.error(intl.formatMessage(messages.error));
    },
  });

  return {
    assignedUsers: get(data, 'viewer.taskList.assignedUsers.nodes', []),
    loading,
    error,
    featureSet: get(data, 'viewer.company.featureSet', {}),
  };
};

export default useTaskListAssignedUsers;
